import { render, staticRenderFns } from "./AccountInvitationCodes.vue?vue&type=template&id=51a32254&"
import script from "./AccountInvitationCodes.vue?vue&type=script&lang=ts&"
export * from "./AccountInvitationCodes.vue?vue&type=script&lang=ts&"
import style0 from "./AccountInvitationCodes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports